import cn from 'classnames'
import React, { ComponentProps } from 'react'

type UploadFileFilledErrorIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function UploadFileFilledErrorIcon(
  props: UploadFileFilledErrorIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('UploadFileFilledErrorIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.59 16.43L16 15.01L12.01 11L8 15.01Z"
        fill={props.fill || '#D5404A'}
      />
    </svg>
  )
}
